var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-content"},[_c('DTComponent',{attrs:{"datatable":_vm.datatable,"classes":"dt_widget"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }